import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { MaterialGroupService } from '../material-group.service';
import MaterialGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity';
import { LOCALIZED_PROPERTIES, MATERIAL_GROUP_EXPORT_ID, MATERIAL_GROUP_TITLE } from './material-group.constants';

@Injectable()
export class MaterialGroupExport {
  constructor(
    private exportService: ExportService,
    private materialGroupService: MaterialGroupService,
  ) {}

  private transformItem(item: MaterialGroupAttributes) {
    return {
      code: get(item, 'code', '??'),
      name: get(item, 'name', '??'),
      type: this.getType(get(item, 'type', '??')),
      company: get(item, 'company.name', '??'),
      division: get(item, 'division.name', '??'),
      hasSubcategories: this.getHasSubcategories(get(item, 'hasSubcategories', '')),
      statusId: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }
  private getType(value: string ): string {
    if(value == 'N') {
        return 'NORMAL';
    }else{

    }
    return 'error';
  }
  private getHasSubcategories(value: boolean | string): string {
    if(value == true) {
        return 'SÍ';
    }else if(value == false){
        return 'NO';
    }
    return 'error'
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: MATERIAL_GROUP_EXPORT_ID,
      title: MATERIAL_GROUP_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(MATERIAL_GROUP_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.materialGroupService.findByFilter(buildQuery(
          seed(this.materialGroupService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(MATERIAL_GROUP_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(MATERIAL_GROUP_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
